import { render, staticRenderFns } from "./MultiSelectDropdown.vue?vue&type=template&id=b6145208&scoped=true"
import script from "./MultiSelectDropdown.vue?vue&type=script&lang=js"
export * from "./MultiSelectDropdown.vue?vue&type=script&lang=js"
import style0 from "./MultiSelectDropdown.vue?vue&type=style&index=0&id=b6145208&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6145208",
  null
  
)

export default component.exports